export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/income-img.500da728.svg","height":96,"width":111};